import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { accountState } from './accountState';
import { AccountsState } from '../types';

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState: accountState,
  reducers: {
    setReports: (state, action: PayloadAction<AccountsState['reports']>) => {
      state.reports = action.payload;
    },
    setAccount: (state, action: PayloadAction<AccountsState['account']>) => {
      state.account = action.payload;
    },
    setAccountMetaTree: (
      state,
      action: PayloadAction<AccountsState['accountMetaTree']>,
    ) => {
      state.accountMetaTree = action.payload;
    },
    setSearchKeyword: (
      state,
      action: PayloadAction<AccountsState['searchKeyword']>,
    ) => {
      state.searchKeyword = action.payload;
    },
    setDocumentType(
      state,
      action: PayloadAction<AccountsState['documentType']>,
    ) {
      state.documentType = action.payload;
    },
    setExportDataRequestPendingTo(
      state,
      action: PayloadAction<AccountsState['isExportDataRequestPending']>,
    ) {
      state.isExportDataRequestPending = action.payload;
    },
    setToggleExportFileModal(
      state,
      action: PayloadAction<AccountsState['isToggleExportFileModal']>,
    ) {
      state.isToggleExportFileModal = action.payload;
    },
    setToggleReportsListModal: (
      state,
      action: PayloadAction<AccountsState['isToggleReportsListModal']>,
    ) => {
      state.isToggleReportsListModal = action.payload;
    },
    setToggleGoogleMapKeyModal: (
      state,
      action: PayloadAction<AccountsState['isToggleGoogleMapApiKeyModal']>,
    ) => {
      state.isToggleGoogleMapApiKeyModal = action.payload;
    },
    setToggleCreateEditAccountModal: (
      state,
      action: PayloadAction<AccountsState['isToggleCreateEditAccountModal']>,
    ) => {
      state.isToggleCreateEditAccountModal = action.payload;
    },
    setLoadingEditAccount: (
      state,
      action: PayloadAction<AccountsState['isLoadingEditAccount']>,
    ) => {
      state.isLoadingEditAccount = action.payload;
    },
    closeCreateEditAccountModal: state => {
      state.isToggleCreateEditAccountModal = false;
      state.account = null;
      state.isLoadingEditAccount = false;
    },
    setResetData: () => accountState,
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: accountsActions } = accountsSlice;

/* ------- STATE SELECTORS ------- */
export const selectAccounts = (state: RootState) => state.accounts;

export default accountsSlice.reducer;
